import styled from 'styled-components';
import { colors, fontWeights, spacing } from 'syf-component-library/defaultTheme';
import { Inset } from 'syf-component-library/ui/spacing';
import SamsLink from '../../../modal/content/utils/SamsLink';
export const StepsContainer = styled(Inset) `
  background: ${colors.lightestGrey};
  border-radius: 8px;
  text-align: left;
`;
export const Step = styled.div `
  display: flex;
  gap: ${spacing.small}px;
`;
export const SamsClubLink = styled(SamsLink) `
  display: inline-flex;
  flex-direction: row-reverse;
  font-weight: ${fontWeights.bold};
  svg {
    padding-left: 5px;
  }
`;
